const wordingSetter = (json) => {
	let target;

	/**
	 * find all element with lang-key
	 */
	Array.from(document.querySelectorAll('[data-lang-key]'))
		.forEach((element) => {
			/**
			 * reset target
			 */
			target = json;

			const langKeyArray = element.dataset.langKey.split('.');
			langKeyArray.forEach((key, index) => {
				/**
				 * it should be a object here and contain this property
				 */
				if (typeof target !== 'object' || !Object.hasOwnProperty.call(target, key)) {
					return;
				}

				/**
				 * go deeper
				 */
				target = target[key];

				/**
				 * it is the last key
				 */
				if (index === langKeyArray.length - 1 && typeof target !== 'object') {
					const langPositionAttr = 'data-lang-position';

					if (element.getAttribute(langPositionAttr)) {
						element.setAttribute(element.getAttribute(langPositionAttr), target);
						element.removeAttribute(langPositionAttr);
					} else {
						element.innerHTML = target;
					}

					element.removeAttribute('data-lang-key');
				}
			});
		});
};

export default wordingSetter;



// WEBPACK FOOTER //
// ./src/js/wordingSetter.js